var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSelectSignout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 281"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 222",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 173",
    d: "M1.919 16a1.836 1.836 0 0 1-1.358-.57A1.9 1.9 0 0 1 0 14.049V1.971A1.93 1.93 0 0 1 .561.576 1.831 1.831 0 0 1 1.919 0h5.035a.986.986 0 0 1 0 1.971H2.419a.5.5 0 0 0-.5.5v11.078a.5.5 0 0 0 .5.5h4.545a.976.976 0 0 1 0 1.951zm7.162-4.3a.971.971 0 0 1-.011-1.365l1.31-1.346H4.591a.975.975 0 1 1 0-1.95h5.752L9.031 5.686a.969.969 0 1 1 1.391-1.35l2.7 2.79a1.3 1.3 0 0 1 0 1.81l-2.661 2.747a.971.971 0 0 1-1.381.013",
    transform: "translate(2.991 2)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSelectSignout);
export default __webpack_public_path__ + "static/media/ic-select-signout.4e0208589affb04bf653ab99cb50d45b.svg";
export { ForwardRef as ReactComponent };